export default __webpack_public_path__ + "static/media/warning_icon.0fcf2670.png";